import { fetchMemberOpportunities, fetchOpportunityByContactId, updateOpportunityNotes } from '../services/opportunities.services';
import { DASHBOARD, REFERRAL } from '_constants';
import { isResponseSuccess } from 'helpers';
import { showServerResponse, throwError } from './modals.actions';
import { updateDocumentMapping } from '../services';
import { taskActions } from './tasks.actions';

const getOpportunities = (memberKey, appointments) => async dispatch => {
  const res = await dispatch(fetchMemberOpportunities(memberKey));
  if (isResponseSuccess(res)) {
    dispatch({ type: DASHBOARD.UPDATE_OPPORTUNITIES, value: { opportunities: res.data } });
  }
  return res;
};

export const opportunitiesActions = {
  getOpportunities
};

export const isOpportunityActive = (opp) => {
  if (!opp) { return false; }
  if (!opp.status) { return true; }
  let isActive = true;
  if (opp.group) {
    isActive = opp.group.toLowerCase() !== 'fallout';
  }
  return isActive && opp.status.toLowerCase() !== 'closed';
};

export const prioritizeOpportunities = (opps) => {
  const activeOpps = []; const inactiveOpps = [];
  opps.forEach(a => {
    if (isOpportunityActive(a)) { activeOpps.push(a); } else { inactiveOpps.push(a); }
  });

  return [...activeOpps.sort((a, b) => a.type < b.type ? 1 : -1), ...inactiveOpps.sort((a, b) => a.type < b.type ? 1 : -1)];
};

export const fetchOpportunityById = (contactId, oppId) => async (dispatch) => {
  dispatch({ type: REFERRAL.ACTION.START_FETCH_OPPORTUNITY_DATA });
  try {
    const response = await dispatch(fetchOpportunityByContactId(contactId, oppId));
    if (isResponseSuccess(response)) {
      dispatch({ type: REFERRAL.ACTION.FETCH_OPPORTUNITY_INFO, value: response.data });
    }
    return response;
  } catch (err) {
    console.error(err);
    return Promise.reject(err);
  } finally {
    dispatch({ type: REFERRAL.ACTION.END_FETCH_OPPORTUNITY_DATA });
  }
};

export const updateStatus = (contactId, opportunityId, payload, isResubmit, routeTo) => async (dispatch) => {
  dispatch({ type: REFERRAL.ACTION.START_UPDATING_OPPORTUNITY_STATUS });
  try {
    const response = await dispatch(updateOpportunityNotes(contactId, opportunityId, payload));
    if (isResponseSuccess(response)) {
      dispatch({ type: REFERRAL.ACTION.UPDATING_OPPORTUNITY_STATUS, value: response.data });
      dispatch(showServerResponse(response, 'Weekly Status Updated', 'Erorr Updating Status', routeTo));
    }
    return response;
  } catch (err) {
    console.error(err);
    if (err.response.status === 409 && !isResubmit) {
      return err.response;
    } else {
      dispatch(throwError(routeTo, 'Error Updating Status'));
      Promise.reject(err);
    }
  } finally {
    dispatch(taskActions.fetchTasks());
    dispatch({ type: REFERRAL.ACTION.END_UPDATING_OPPORTUNITY_STATUS });
  }
};

export const markOpportunityDocumentRead = (documentMapping = {}) => async dispatch => {
  if (!documentMapping || !documentMapping.opportunityId || !documentMapping.documentId) {
    return Promise.reject(new Error('Document null or Opportunity Id or Document Id missing'));
  }

  if (documentMapping.isRead === true) {
    return true;
  }

  documentMapping.isRead = true;
  const res = await dispatch(updateDocumentMapping(documentMapping));
  return res;
};
